import { NavLink } from 'react-router-dom';
import { UtensilsCrossed } from 'lucide-react';
import { NAV_ITEMS, NAV_SECTIONS } from '../../config/nav';
import { usePermission } from '../../hooks/usePermission';
import { useAuthStore } from '../../store/authStore';
import { cn } from '../../lib/cn';

export function Sidebar({ onNavigate }: { onNavigate?: () => void }) {
  const { hasAnyPermission } = usePermission();
  const business = useAuthStore((s) => s.business);

  const visibleItems = NAV_ITEMS.filter((item) => !item.anyOf || hasAnyPermission(item.anyOf));

  return (
    <div className="flex h-full flex-col bg-ink-900 text-ink-100">
      <div className="flex items-center gap-2.5 px-5 py-5">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-500 text-white">
          <UtensilsCrossed className="h-5 w-5" />
        </div>
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold text-white">
            {business?.businessName ?? 'Fast Food POS'}
          </p>
          <p className="text-xs text-ink-400">Point of Sale</p>
        </div>
      </div>

      <nav className="flex-1 space-y-6 overflow-y-auto px-3 pb-6">
        {NAV_SECTIONS.map((section) => {
          const items = visibleItems.filter((item) => item.section === section);
          if (items.length === 0) return null;
          return (
            <div key={section}>
              <p className="px-3 pb-2 text-[11px] font-semibold uppercase tracking-wider text-ink-500">
                {section}
              </p>
              <ul className="space-y-1">
                {items.map((item) => (
                  <li key={item.to}>
                    <NavLink
                      to={item.to}
                      onClick={onNavigate}
                      className={({ isActive }) =>
                        cn(
                          'flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition',
                          isActive
                            ? 'bg-brand-500 text-white'
                            : 'text-ink-300 hover:bg-ink-800 hover:text-white',
                        )
                      }
                    >
                      <item.icon className="h-[18px] w-[18px]" aria-hidden />
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </nav>
    </div>
  );
}
